import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';

interface Args {
	onClose: () => void;
}

export default class AppNotificationsCardExpirationComponent extends Component<Args> {
	@service('billing') declare billingService: Service.Billing;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('current-user') declare currentUserService: Service.CurrentUser;

	@action
	takeAction() {
		const currentRoute = String(this.navigationService.activatedRoute);

		if (currentRoute.startsWith('settings.billing')) {
			this.billingService.changePayment();
		} else {
			this.navigationService.transitionToRoute('settings.billing');
		}
	}
	<template>
		<div class="notification-container card-expiration-notification">
			<div class="container">
				<a role="button" class="close" {{on "click" @onClose}}>
					<CommonUiIconComponent @name="Close" @size="sm" />
				</a>

				<p>
					<CommonUiIconComponent @name="InfoFill" @size="sm" />
					<strong>Your credit card will expire soon.</strong>
					Please update it to continue using Databox without interruption.
				</p>
				{{#if this.currentUserService.isAdmin}}
					<a {{on "click" this.takeAction}}>Update billing info</a>
				{{/if}}
			</div>
		</div>
	</template>
}
